{
  "common": {
    "send": "Send",
    "card": "Card",
    "service": "Service",
    "plan": "plan",
    "next": "Next",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "backToLogin": "Back to sign in",
    "not_specified": "Not specified"
  },
  "setting": {
    "update_title": "New version available",
    "update_text": "Update to load the latest changes to the portal.",
    "update_action": "Update"
  },
  "plan": {
    "estatus": "Status",
    "next_invoice": "Next invoice",
    "type": "Type",
    "cut_off": "Cutoff date",
    "subscription": "Subscription",
    "bank_reference": "Bank reference",
    "address": "Address",
    "view_detail": "View details",
    "subscription_on": "Active",
    "subscription_off": "Inactive",
    "contract": "Contract"
  },
  "titles": {
    "Home": "Home",
    "Profile": "Profile",
    "SupportIndex": "Support tickets",
    "SupportAdd": "New ticket",
    "ChangePass": "Change password",
    "PlanDetails": "",
    "InvoicesView": "",
    "InvoicesPay": "Pay invoice",
    "QuickPaymentSuccess": "",
    "Login": "",
    "QuickPayment": "",
    "LeadForm": "",
    "ResetPass": "",
    "AddressForm": "",
    "NewUser": "",
    "QuickPaymentInvoices": "Quick payment",
    "SentryTest": "Sentry check"
  },
  "ticket": {
    "close_date": "Close date",
    "create_date": "Creation date",
    "open": "Open",
    "closed": "Closed",
    "new": "New ticket",
    "empty_title": "No tickets here",
    "empty_subtitle": "Need a hand? Create a ticket and we will get in touch."
  },
  "menu": {
    "home": "Home",
    "support": "Support"
  },
  "userOptions": {
    "profile": "Profile",
    "changePass": "Change password",
    "forgotPass": "Forgot my password",
    "logout": "Logout",
    "newUser": "Are you a GigNet customer and you don't have your username yet? Click here"
  },
  "password_reset": {
    "button": "Request new password",
    "check_mail": "Check your inbox for the next steps or check your spam folder",
    "valid_email": "Valid email",
    "success": "Success!",
    "password_changed": "Password changed",
    "title": "Reset your password",
    "subtitle": "Enter the email linked to your account and we'll send you the instructions.",
    "error_title": "We couldn't send the email",
    "error_subtitle": "Check the email you entered and try again."
  },
  "map": {
    "select_address": "Coverage areas are displayed in blue.",
    "selected_address": "Selected address"
  },
  "lead": {
    "form_name": "Contact us",
    "name": "Business name",
    "contact_name": "Contact name",
    "email": "Email",
    "mobile": "Phone number",
    "street": "Street",
    "type_service": "Type of service",
    "location_of_service": "Location of service",
    "success_title": "Success",
    "success_subtitle": "Customer service will contact you"
  },
  "login": {
    "title": "Already a GigNet customer?",
    "username": "Username",
    "password": "Password",
    "send": "Login",
    "quick": "Quick payment",
    "client": "I want to be a customer",
    "call": "Support",
    "notice": "By using this platform, you agree to our <a target='_BLANK' href='https://gignetmexico.com/nosotros/aviso-privacidad/'> privacy policies </a>",
    "error_title": "Error",
    "error_subtitle": "Incorrect email or password",
    "subtitle": "Sign in to manage your service",
    "legal": "GigNet, S.A. de C.V. México through its subsidiary, SanAlto Redes Peninsular, S.A.P.I. de C.V., concessionaire of the contracted SERVICE."
  },
  "register": {
    "error_title": "Error",
    "error_subtitle": "Service number not found",
    "title": "Create your username",
    "subtitle": "Enter your service number and we'll email you your access details."
  },
  "changePass": {
    "current": "Current",
    "new": "New",
    "confirm": "Confirm New",
    "success_title": "Success",
    "success_subtitle": "Your password has been successfully changed",
    "error_title": "Error",
    "error_subtitle": "There was an error changing the password",
    "card_title": "Choose a new password",
    "card_subtitle": "You need your current password to confirm the change.",
    "mismatch": "The passwords don't match."
  },
  "homepage": {
    "my_services": "My services",
    "hello": "Hello {name}!",
    "subtitle": "Check the status of your services and invoices.",
    "empty_title": "You have no services yet",
    "empty_subtitle": "Once a service is activated under your name it will show up here."
  },
  "credit_card": {
    "expires": "Expires",
    "number": "Number",
    "add_error": "Unable to add card",
    "exp_month": "Month",
    "exp_year": "Year",
    "cvc": "CVC",
    "new": "New card",
    "select": "Select",
    "write": "Write",
    "checkbox": "I authorize to carry out billing activities and process payments through the forms and mechanisms enabled by GIGNET, related to the use of goods and/or services provided by third parties."
  },
  "support": {
    "type": "Type of ticket",
    "types": {
      "service_failures": "Service failures",
      "payments": "Payments & invoices",
      "plans": "Plans"
    },
    "description": "Description",
    "send": "Send"
  },
  "services": {
    "service": "Service #"
  },
  "payment": {
    "success_title": "Payment successful!",
    "success_description": "The invoice has been sent to the assigned email",
    "success_button": "Ok",
    "subscription": {
      "button_action": "Pay my bills and set up automatic payments.",
      "title": "You have a subscription!",
      "subtitle": "Payment will be made automatically"
    },
    "subscription_in_process": {
      "title": "A payment is already being processed",
      "subtitle": "This invoice has a payment pending validation, so Autopay cannot be activated right now to avoid a double charge. Payments may take up to 1 hour to be reflected."
    },
    "subscription_disabled": {
      "title": "We were unable to complete your request.",
      "subtitle": "You may have more than one unpaid invoice, which prevents Autopay from being activated at this time. Please contact us for assistance: 998 690 0690"
    },
    "info": "Thank you very much for your payment, this will be reflected in a period of no more than one hour."
  },
  "profile": {
    "username": "Username",
    "name": "Name",
    "email": "email",
    "street": "Street",
    "save": "Save",
    "business_name": "Business name",
    "phone": "Phone",
    "city": "City",
    "street_number": "Street Ext",
    "street_number2": "Street Int",
    "colony": "Colony",
    "locality": "Locality",
    "reference": "Reference",
    "vat": "Tax ID"
  },
  "quickpayment": {
    "notfound_title": "No results found",
    "notfound_subtitle": "No results found for the requested service.",
    "continue": "Search",
    "clean": "Clean results",
    "cc_label": "Enter your credit card details to continue.",
    "service_number": "Contract number",
    "pay": "Pay",
    "subscribe": "Subscribe",
    "error_title": "Error",
    "error_subtitle": "There was an error processing the payment",
    "check": "I have verified that my information is correct.",
    "caption": "Check that the information matches your contract number, to avoid erroneous payment for your service. For your greater security, you are always invited to enter the portal with your username and password to make your payment(s).",
    "info": "We remind you that payments can be reflected in a period of no more than one hour."
  },
  "invoices": {
    "invoice": "Invoice",
    "id": "ID",
    "name": "Name",
    "partner_id": "Client",
    "plan": "Plan",
    "reference": "Bank reference",
    "next_invoice_date": "Next invoice date",
    "subscription": "Subscription",
    "summary_amount": "Total outstanding amount",
    "summary_payment": "Payment amount",
    "summary_pending": "Pending Amount",
    "servicio_id": "Service",
    "invoice_date": "Date",
    "invoice_payment_term_id": "Term",
    "amount_total": "Total",
    "amount_residual": "Residual",
    "state": "State",
    "paid": "Paid",
    "pay": "Pay",
    "pending_helper": "You have previous unpaid invoices.",
    "message_header": "Autopay can only be activated if you have a single unpaid invoice. If you have more than one overdue invoice, please contact our customer support team to help regularize your account before enabling Autopay. 998 690 0690",
    "subscription_helper": "The service has a subscription, the charge is automatic to your card",
    "message_info_confirm": "Click this box to enable Autopay.",
    "confirm": "I hereby authorize GigNet, S.A. de C.V, so that I can charge my credit or debit card, the amount for the services that it provides me monthly.",
    "cancelled": "Cancelled",
    "not_payed": "Not paid",
    "filter_by": "Filter by",
    "pending_payment": "Processing",
    "message_empty": "There are no invoices pending payment",
    "title": "Invoices",
    "due_date": "Due date",
    "amount_paid": "Paid",
    "view_detail": "View invoice",
    "overdue": "Overdue",
    "due_on": "Due on {date}",
    "overdue_on": "Was due on {date}",
    "paid_on": "Paid on {date}",
    "pending_count": "Pending invoices: {count}",
    "tag_reconnection": "Reconnection",
    "tag_penalty": "Penalty",
    "tag_equipment": "Equipment",
    "tag_excess": "Overage",
    "cfdi_cancelled": "CFDI cancelled",
    "state_draft": "Draft",
    "state_posted": "Posted",
    "state_cancel": "Cancelled",
    "amount_untaxed": "Subtotal",
    "amount_tax": "Tax"
  },
  "contract": {
    "contact_form": {
      "fiscal_data": "IMPORTANT: Please review your billing information carefully. Once the invoice has been issued, it cannot be canceled or modified. Any updates to your tax information will be applied to the next billing cycle.",
      "form_name": "Contact info",
      "id_vendedor": "Seller ID (to be filled by sales if applicable)",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "mobile": "Mobile Phone",
      "identificacion": "ID",
      "identificacion_posterior": "ID back",
      "comprobante": "Proof of address",
      "constancia_situacion_fiscal": "Situation fiscal certificate",
      "business_name": "Name or Business name",
      "identification": "Identification",
      "invoice_check": "I require fiscal invoice",
      "check": "I have verified that my information is correct and I accept the <a target='_blank' href='https://gignet.mx/es/politica-privacidad/'>Privacy policy<a>."
    },
    "address_form": {
      "form_name": "Address of the installation",
      "coverage_zone": "Coverage Zone",
      "type_locality": "Settlement type",
      "street": "Address",
      "ext": "#Ext",
      "int": "#Int",
      "city": "City",
      "suburb": "Colony",
      "zip_code": "Zip code",
      "settlement": "Settlement",
      "aditional_info": "Additional info",
      "referal": "How did you hear about us?",
      "channel_other": "Please specify"
    }
  },
  "wizard_contract": {
    "steps": {
      "map": "Location",
      "plans": "Plans",
      "customer": "Customer",
      "contract": "Contract",
      "end": "End"
    },
    "address": {
      "title": "Check availability for new residential services.",
      "city": "City",
      "zone": "Zone",
      "township": "Address",
      "building": "Building",
      "btn_send": "Next",
      "btn_back": "Back",
      "box_header_text": "Don’t see your community?",
      "box_body_text": "We're always expanding our network. If you don't see your community listed above, contact us using the form below to let us know you're interested in GigNet Home services.",
      "btn_fillform": "Fill Form"
    },
    "map": {
      "instruction": "Tap the map to mark your location or use the button to detect it automatically.",
      "locate_btn": "My location",
      "locating": "Detecting..."
    },
    "plans": {
      "title": "Select your package",
      "prefix": "Up to",
      "period": "Monthly",
      "install": "Installation",
      "install_free": "Free",
      "label_promotion": "Up to"
    },
    "contact": {
      "title": "Contact Information",
      "name": "name",
      "email": "email",
      "phone": "phone",
      "city": "City",
      "colony": "Address",
      "building": "Building or Residential Complex",
      "zip": "zip",
      "link_maps": "GPS Location",
      "comment": "Additional information",
      "info_gps": "If you are in the location of the service, click on the icon to generate your GPS location",
      "gps_steps": {
        "one": "On your phone, tablet, or computer, open the Google Maps app",
        "two": "Search for the place or locate it on the map and hold it down to put a pin.",
        "three": "At the top of the screen, select the site link.",
        "four": "Right-click it and select Copy.",
        "five": "Hit paste with the secondary button in the section where it asks you."
      },
      "btn_send": "Send"
    },
    "end": {
      "title": "We have received your signed contract!<br> What’s next? ✍🏼 <br> Once your signature is validated, we will coordinate the installation. 👩🏻‍💻 Our Customer Service team will contact you via phone or email.",
      "subtitle": "Note: If the signature does not match your ID, we will send you a new link via email. For any questions or follow-up, please contact your sales executive at 998 690 0610.",
      "phone": "9986900610",
      "label": "The end"
    }
  },
  "signature": {
    "check": "I agree with the terms and conditions of contracting the service of GigNet S.A. de C.V.",
    "save": "Save",
    "clear": "Clear"
  },
  "image_crop": {
    "title": "Attach document with signature",
    "badge_label": "CROP",
    "label": "Load image",
    "hint": "Select the area to crop",
    "accepted_hint": "JPG, PNG, WEBP (max. 5MB)",
    "error_message": "Unable to load image"
  }
}
